import styled, { css } from 'styled-components';
import { Space, Spin, Button, Select } from 'antd';

const compareModeStyles = css`
  border-left: 5px solid #3392ed;
`;

export const Container = styled.div<{ $compareMode?: boolean; $comareSeries?: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
  margin-left: 6px;
  border-radius: 4px;
  max-width: 100%;
  max-height: 200px;
  overflow: hidden auto;

  ${(props) => {
    if (props.$compareMode && props.$comareSeries) {
      return css`
        padding: 3px 6px;
        background-color: rgb(15 147 245 / 25%);
        border: 1px solid #3392ed;
        ${compareModeStyles}

        > span {
          background-color: #fff;
        }
      `;
    }

    if (props.$compareMode) {
      return css`
        padding: 4px 6px;
        background-color: #f5f5f5;
        ${compareModeStyles}
      `;
    }

    return css`
      padding: 4px 0;
    `;
  }}
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  overflow: hidden;
  border-radius: 4px;
`;

export const AtomContainer = styled.span<{ $disabled?: boolean; $disabeldHoverStyle?: boolean }>`
  padding: 0 8px;
  height: 32px;
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  color: #3b3b3b;
  font-size: 16px;
  line-height: 30px;
  gap: 4px;
  user-select: none;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) => {
    if (props.$disabled)
      return css`
        pointer-events: none;

        span:not([role='img']) {
          color: rgb(0 0 0 / 25%);
        }
      `;

    if (props.$disabeldHoverStyle) {
      return css`
        span:not([role='img']) {
          color: rgb(0 0 0 / 25%);
        }
      `;
    }

    return css`
      cursor: pointer;

      :hover {
        border-color: #2969ff;
      }
    `;
  }}
`;

export const SavedFilterSelectorDropdownContainer = styled.div`
  .ant-select-item-group {
    font-size: 14px;
    font-style: italic;
  }

  .ant-select-item-option-grouped {
    padding-inline-start: 12px;
  }
`;

export const AtomSpaceCompact = styled(Space.Compact)`
  display: flex;
  max-width: 100%;
  border-radius: 6px;
`;

export const DropdownSpin = styled(Spin)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
`;

export const AtomInnerRemoveButton = styled(Button)<{ $forceDisplay?: boolean }>`
  flex: none;
  align-self: center;
  pointer-events: initial;

  ${(props) => {
    if (props.$forceDisplay) {
      return css`
        display: inline-block;
      `;
    }

    return css`
      position: absolute;
      right: 2px;
      display: none;
      background-color: #fcfcfc;

      &.ant-btn-text:not(:disabled) {
        :hover {
          background-color: #f0f0f0;
        }

        :active {
          background-color: #d9d9d9;
        }
      }
    `;
  }}

  &.ant-btn.ant-btn-sm {
    font-size: 12px;
    line-height: 24px;
  }
`;

export const Relation = styled.span`
  font-size: 14px;
  color: #686868;
`;

export const Operator = styled.span`
  font-size: 12px;
  color: #686868;
  text-transform: uppercase;
`;

export const AtomEditableBlock = styled.span<{ $disabled?: boolean }>`
  margin: 3px 0;
  padding: 0 4px;
  line-height: 24px;
  border-radius: 4px;

  ${(props) =>
    props.$disabled
      ? ''
      : css`
          :hover {
            background-color: rgb(0 0 0 / 6%);
          }

          :active {
            background-color: rgb(0 0 0 / 15%);
          }
        `}
`;

export const AtomEditableRuleValue = styled(AtomEditableBlock)`
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  overflow: hidden;

  > span:nth-child(odd) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 360px;
  }

  /* > span:nth-child(even):not(:last-child) {
    color: #686868;
    font-size: 12px;
    text-transform: uppercase;
  } */
`;

export const RestTips = styled.span`
  font-weight: 700;
  color: #a0a0a0;

  ::before {
    content: ',';
    margin: 0 4px 0 -4px;
    font-weight: 400;
    color: #3b3b3b;
  }

  ::after {
    content: '...';
  }
`;

export const TextEllipsisBlock = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
`;

export const AtomOperatorSelector: typeof Select = styled(Select)`
  align-self: center;
  padding: 2px 0;
  background: #eee;
  background-clip: content-box;
  border-radius: 4px;

  .ant-select-selector {
    padding: 0 4px !important;
  }

  .ant-select-selection-item {
    padding-inline-end: 14px !important;
  }

  .ant-select-arrow {
    right: 4px !important;
  }

  ${(props) => {
    if (props.disabled) {
      return css`
        .ant-select-selector {
          cursor: initial !important;
        }

        .ant-select-arrow {
          display: none;
        }

        .ant-select-selection-item {
          padding-inline-end: 0 !important;
        }
      `;
    }

    return ``;
  }}
`;

export const RuleAtomContainer = styled(AtomContainer)<{ $active?: boolean; $error?: boolean }>`
  position: relative;
  align-items: baseline;
  min-width: 54px;
  justify-content: center;

  ${(props) => {
    if (props.$error) {
      return css`
        position: initial;
        border-color: #ff4d4f;
        box-shadow: 0 0 0 2px rgb(255 38 5 / 6%);

        :hover {
          border-color: #ff4d4f;
        }
      `;
    }

    if (props.$active) {
      return css`
        position: initial;
        border-color: #1677ff;
        box-shadow: 0 0 0 2px rgb(5 145 255 / 10%);
      `;
    }

    return '';
  }}

  :hover {
    justify-content: flex-start;

    ${AtomInnerRemoveButton} {
      display: inline-block;
    }
  }
`;

export const StyledWarningIcon = styled.span`
  display: inline-block;
  margin: 5px;
  color: #fa8c16;
`;

export const StyledWarningTags = styled.div`
  padding: 5px;

  a {
    padding: 0;
  }
`;
